import React, { FC } from 'react';

import { ClassName, cn } from '../../utils';
import styles from './index.module.scss';


export type ProgressBarProps = ClassName & {
    value?: number;
    indeterminate?: boolean;
};

const progressStyle = (value: number) => ({
    transform: `translateX(-${(1 - value) * 100}%)`,
});

export const ProgressBar: FC<ProgressBarProps> = ({
    className,
    value,
    indeterminate,
}: ProgressBarProps) => (
    <div className={cn(styles.progressBar, className)}>
        <div
            className={cn(
                styles.progress,
                indeterminate && styles.indeterminate,
            )}
            style={progressStyle(value)}
        />
    </div>
);
